module.exports = __webpack_public_path__ + "img/icon_arrow.808ed85c.svg";